// Module
var code = " <div class=\"react-container\"> <pricing-page/> </div> ";
// Exports
module.exports = code;